const images = ref([])
const indexRef = ref(0)
const visibleRef = ref()

export function useLightbox() {
  const router = useRouter()

  const setImages = (imgs) => images.value = (Array.isArray(imgs) && imgs.length) ? imgs : []

  const openLightbox = (index) => {
    // console.log(images.value)
    indexRef.value = index;
    visibleRef.value = true;
  }

  const closeLightbox = () => visibleRef.value = false

  router.afterEach(() => closeLightbox())

  return {
    images: readonly(images),
    indexRef,
    visibleRef,
    setImages,
    openLightbox,
    closeLightbox,
  }
}
